import { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './sidebar.scss';
import styled from 'styled-components';
import LogoPU from "./static/img/pu-logo.png";
import AuthService from "../../services/auth.service";

import {
    VStack,
    HStack,
    Text,
} from '@chakra-ui/react';

const ImageCard = styled.img`
    width: 20%;
    height: 20%;
    margin-left: 15px;
    object-fit: cover;
    border-radius: 50px;

    @media screen and (max-width: 873px){
        width: 285px;
        max-height: 115px;
        margin-left: 38px;
     };
`;

const currentUser = AuthService.getCurrentUser();
let idMentor;
if (currentUser != undefined) {
    if (currentUser.mentor != null) {
        currentUser.mentor.map((data) => idMentor=data.idMentor)
        console.log(idMentor)
    }
}

const sidebarNavItems = [
    {
        display: 'Profil',
        icon: <i className='bx bx-user'></i>,
        to: `/mentor/profile/lihat/${idMentor}`,
        section: 'lihat'
    },
    {
        display: 'Manajemen Mentee',
        icon: <i className='bx bx-group'></i>,
        to: `/mentor/manajemenmentee/list-mentee/${idMentor}`,
        section: 'list-mentee'
    },
    {
        display: 'Ganti Sandi',
        icon: <i className='bx bx-key'></i>,
        to: '/mentor/profile/change-password',
        section: 'change-password'
    },
    {
        display: 'Kembali',
        icon: <i className='bx bx-log-out'></i>,
        to: '/',
        section: 'kembali'
    },
]

const SidebarMentor = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [stepHeight, setStepHeight] = useState(0);
    const sidebarRef = useRef();
    const indicatorRef = useRef();
    const location = useLocation();
    const [currentUser, setCurrentUser] = useState([]);

    useEffect(() => {
        const user = AuthService.getCurrentUser();
    
        if (user) {
            setCurrentUser(user);
        }
    }, [])

    useEffect(() => {
        setTimeout(() => {
            const sidebarItem = sidebarRef.current.querySelector('.sidebar__menu__item');
            indicatorRef.current.style.height = `${sidebarItem.clientHeight}px`;
            setStepHeight(sidebarItem.clientHeight);
        }, 50);
    }, []);


    useEffect(() => {
        const curPath = window.location.pathname.split('/')[3];
        const activeItem = sidebarNavItems.findIndex(item => item.section === curPath);
        setActiveIndex(curPath.length === 0 ? 0 : activeItem);
    }, [location]);

    return <div className='sidebar'>
        <div className="sidebar__logo">
            Dashboard 
        </div>
        {currentUser.mentor && currentUser.mentor.map((data) =>
        <HStack pb={8}>
            <ImageCard src={LogoPU}/>
            <VStack align='stretch'>
                <span style={{fontSize: '18px', fontWeight: '700'}}>{data.namaMentor}</span>
                <span style={{fontSize: '12px', fontWeight: '400'}}>{currentUser.emailUser}</span>
            </VStack>
        </HStack>)}
        <Text style={{fontSize: '14px', fontWeight: '700'}} pl={6} pt={4} pb={6}> Halaman Akun </Text>
        <div ref={sidebarRef} className="sidebar__menu">
            {
                sidebarNavItems.map((item, index) => (
                    <Link to={item.to} key={index}>
                        <div className={`sidebar__menu__item ${activeIndex === index ? 'active' : ''}`}>
                            <div className="sidebar__menu__item__icon">
                                {item.icon}
                            </div>
                            <div className="sidebar__menu__item__text">
                                {item.display}
                            </div>
                        </div>
                    </Link>
                ))
            }
        </div>
    </div>;
};

export default SidebarMentor;
